// extracted by mini-css-extract-plugin
export default {"container":"Address_container__sY1qN","wrapper":"Address_wrapper__RERpu"};